export const ESCAPE = 27;
export const ENTER = 13;
export const SPACE = 32;
